// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View2_wrapper__15G7t","topRow":"View2_topRow__kuglE","user":"View2_user__eLBQx","mainUser":"View2_mainUser__2lqon","bottomRow":"View2_bottomRow__14diT"};